import { Observable } from 'rxjs';

export abstract class GtmRepository {
    abstract setDataLayer<T extends object>(dataLayer: T): Observable<void>;
}
